import { memo } from 'react';
import WithDriverIconPopup from './WithDriverIconPopup';

function ReturnToTerminalMarker({ backgroundColor, borderColor }) {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_3950_620)">
        <path
          d="M28 12C28 5.37258 22.6274 0 16 0C9.37258 0 4 5.37258 4 12C4 18.6274 9.37258 24 16 24C22.6274 24 28 18.6274 28 12Z"
          fill={backgroundColor}
        />
        <path
          d="M16 1C22.07 1 27 5.93 27 12C27 18.07 22.07 23 16 23C9.93 23 5 18.07 5 12C5 5.93 9.93 1 16 1ZM16 0C9.37 0 4 5.37 4 12C4 18.63 9.37 24 16 24C22.63 24 28 18.63 28 12C28 5.37 22.63 0 16 0Z"
          fill={borderColor}
          fillOpacity="0.87"
        />
        <path
          d="M16 9V19"
          stroke={borderColor}
          strokeOpacity="0.87"
          strokeWidth="3"
          strokeMiterlimit="10"
        />
        <path
          d="M22 9H10"
          stroke={borderColor}
          strokeOpacity="0.87"
          strokeWidth="3"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <filter
          id="filter0_d_3950_620"
          x="0"
          y="0"
          width="32"
          height="32"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB">
          <feFlood floodOpacity ="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_3950_620" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_3950_620"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default WithDriverIconPopup(memo(ReturnToTerminalMarker));
